'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var nav_module = require('./nav.module.scss.js');
var ChevronRightIcon = require('../alloy-icon/ChevronRightIcon.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var NavLink = react.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, href = _a.href, _d = _a.isActive, isActive = _d === void 0 ? false : _d, _e = _a.linkClassName, linkClassName = _e === void 0 ? '' : _e, showArrow = _a.showArrow, _f = _a.variant, variant = _f === void 0 ? 'light' : _f, _g = _a.size, size = _g === void 0 ? 'dynamic' : _g, props = tslib.__rest(_a, ["children", "className", "href", "isActive", "linkClassName", "showArrow", "variant", "size"]);
    var containerClassName = cx__default.default('d-block', 'm-auto', 'list-unstyled', 'nav-item', 'mt-0', nav_module.default['nav-item'], nav_module.default["nav-item--".concat(variant)] || '', className);
    var linkClassNameFinal = cx__default.default('text-truncate', 'text-start', 'nav-link', 'p-2', 'text-decoration-none', nav_module.default['nav-link'], { 'btn-sm': size === 'small' }, { 'btn-lg': size === 'large' }, { 'btn-dynamic': size === 'dynamic' }, nav_module.default["nav-link--".concat(variant)] || '', (_b = {}, _b[nav_module.default['nav-link--active']] = isActive, _b), linkClassName);
    return (jsxRuntime.jsx("li", tslib.__assign({ className: containerClassName, role: "menuitem" }, { children: jsxRuntime.jsxs("a", tslib.__assign({ className: cx__default.default('d-flex', 'w-100', 'btn', 'btn-ghost', linkClassNameFinal, {
                'pe-3': showArrow
            }), "data-testid": "nav-link", href: href, ref: ref }, props, { children: [jsxRuntime.jsx("div", tslib.__assign({ className: "align-items-center text-truncate" }, { children: children })), showArrow && (jsxRuntime.jsx(ChevronRightIcon.default, { className: nav_module.default['nav-item-icon'] }))] })) })));
});
NavLink.displayName = 'NavLink';
var NavLink$1 = NavLink;

exports.default = NavLink$1;
//# sourceMappingURL=NavMenuLink.js.map
